import React from 'react';
import { useAskQuick } from './AskQuickContext';
import { ASK_QUICK_CHAT_URL } from './AskQuickConstants';
import './AskQuickPanel.scss';

export const AskQuickPanel: React.FC = () => {
  const { isOpen } = useAskQuick();

  if (!isOpen) return null;

  return (
    <div className="ask-quick-panel">
      <div className="ask-quick-panel__content">
        <iframe
          className="ask-quick-panel__iframe"
          src={ASK_QUICK_CHAT_URL}
          title="Ask Quick Chat Agent"
          allow="clipboard-read https://us-east-1.quicksight.aws.amazon.com; clipboard-write https://us-east-1.quicksight.aws.amazon.com"
        />
      </div>
    </div>
  );
};
